<div id="Login_section">
  <section class="singUp-area section-py-120">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-6 col-lg-8">
          <div class="singUp-wrap">
            <h2 class="title">Forgot Password</h2>
            <p>Hey there! Did you forgot your password?<br /></p>
            <div class="account__divider"></div>
            <form [formGroup]="idForm" novalidate class="account__form">
              <div class="form-grp">
                <label class="inline"
                  >Email <span class="text-danger">*</span></label
                >
                <div
                  class="form-grp"
                  [ngClass]="{
                    'has-error': !idf['email'].valid && submitted
                  }"
                >
                  <input
                    type="email"
                    class="form-control"
                    formControlName="email"
                  />
                </div>
              </div>
              <br />

              <button class="btn btn-two arrow-btn" (click)="onSubmit()">
                Submit<img
                  src="assets/img/icons/right_arrow.svg"
                  alt="img"
                  class="injectable"
                />
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
